const BASEURl = process.env.VUE_APP_URL_BASE;

let user = {};

try {
  user = JSON.parse(localStorage.getItem("user"));
} catch (e) {
  console.log(e);
  user = {};
}

export const getUser = () => {
  try {
    user = JSON.parse(localStorage.getItem("user"));
    console.log("user", user);

    return user;
  } catch (e) {
    console.log(e);
    user = {};
  }
};

export const obterIdDaUrl = () => {
  // Pegar o último segmento da URL atual
  const caminhoUrl = window.location.pathname;
  const segmentos = caminhoUrl.split("/").filter((segment) => segment); // Remove strings vazias

  // O último elemento será o ID
  const idServico = segmentos[segmentos.length - 1];

  // Se for um número válido, atribuir ao id_servico
  if (idServico && !isNaN(parseInt(idServico))) {
     
    return parseInt(idServico);
  } else {
    console.error("ID do serviço não encontrado na URL");
  }
};

export const colors = () => {
  return {
    primary: "#3f51b5",
    secondary: "#b0bec5",
    accent: "#8c9eff",
    error: "#b71c1c",
  };
};

export const baseURl = process.env.VUE_APP_URL_BASE;

export const id = user?.id || 0;

export const fullUserData = user;

export const UserData = {
  id: user?.id || 10,
  user: user?.user || "administrator",
};
